import { Component, OnInit, NgZone } from "@angular/core";
import { ActivatedRoute, Routes, Router } from "@angular/router";
import { WorkOrderService } from "../../services/work-order.service";
import { ClientService } from "../../services/client.service";
import { ProjectService } from "../../services/project.service";
import { UserService } from "../../services/usuario.service";
import { environment } from "../../../../environments/environment";
import { NgForm } from "@angular/forms";
import { NotifierService } from "../../shared/notifier/notifier.service";
import { LocalDataSource } from "ng2-smart-table";
import * as moment from "moment";
import * as fileSaver from "file-saver";
import { ReportesService } from "../../services/reportes.service";
import { FormControl } from "@angular/forms";
import { Observable } from "rxjs";
import { DateAdapter, MatDialog } from "@angular/material";
import { map, startWith } from "rxjs/operators";
import { AlertComponent } from "../../shared/alerts/alert.component";
import { RegisterPieceDialogComponent } from "../register-piece-dialog/register-piece-dialog.component";
import { PieceService } from "../../services/piece.service";
import { CampaignTypeService } from "../../services/campaign-type.service";
import { ReportPieceDialogComponent } from "../report-piece-dialog/report-piece-dialog.component";

@Component({
  selector: "app-new-work-order",
  templateUrl: "new-work-order.component.html",
  styleUrls: ["new-work-order.component.scss"],
  providers: [
    WorkOrderService,
    ClientService,
    ReportesService,
    UserService,
    ProjectService,
    PieceService,
    CampaignTypeService
  ],
})
export class NewWorkOrderComponent implements OnInit {
  clientData: any = { name: "" };
  listClients: Array<IClient> = [];
  listCampaignTypes: ICampaignType[] = [];
  workOrderData: IWorkOrder;
  paramId: number;
  clientWindow: Window;
  projects: Array<any> = [];
  users: Array<any> = [];
  newClient: any;
  contactList = [];

  usuarioList: Array<any>;
  projectList: Array<any>;
  idprojecto;

  tableSettingsInternalWorkOrder: any = undefined;
  dataSourceInternalWorkOrder: any = undefined;
  tableDataInternalWorkOrder: any = {};
  perPage = 10;
  settings = {
    pager: { display: true, perPage: this.perPage },
    noDataMessage: "No hay datos que mostrar.",
    columns: undefined,
    actions: {
      add: false,
      delete: false,
      position: "right",
      edit: false,
      columnTitle: "Acciones",
      custom: [
        { name: "editar", title: `<div class="editCustomButton">Editar</div>` },
        {
          name: "eliminar",
          title: `<div class="editCustomButton">Eliminar</div>`,
        },
      ],
    },
  };

  tableSettingsPiece: any = undefined;
  dataSourcePiece: any = undefined;

  arrDataPiece = [];
  tableDataPiece: any = {
    columns: {
      year: { title: "Año" },
      month: { title: "Mes" },
      piece: { title: "Tipo de Pieza" },
      detail: { title: "Detalle" },
      format_name: { title: "Formato" },
      work_type_name: { title: "Estado de Orden" },
      created_by: { title: "Creado por" },
      created_date: { title: "Fecha de creación" }
    },
    data: {},
  };

  settingsPiece = {
    pager: { display: true, perPage: this.perPage },
    noDataMessage: "No hay datos que mostrar.",
    columns: undefined,
    actions: {
      add: false,
      delete: false,
      position: "right",
      edit: false,
      columnTitle: "Acciones",
      custom: [
        { name: "editar", title: `<div class="editCustomButton">Editar</div>` },
        {
          name: "eliminar",
          title: `<div class="editCustomButton">Eliminar</div>`,
        },
      ],
    },
  }

  productsList: any;
  marcasList: any;

  myControl = new FormControl();
  myControl1 = new FormControl();
  options: string[] = [];
  filteredOptions: Observable<string[]>;

  projectSelected = false;

  options1: string[] = [];
  filteredOptions1 = "";
  filteredOptions2 = "";
  tipoList: any[]= [{id:0, nombre:'OT Fuera de Fee'},{id:1,nombre:'OT de FEE'},{id:2,nombre:'OT Proyecto Dentro de FEE'}]
  usersSelected = false;

  rolParaValidar = Number(localStorage.getItem('rolIdUser'));

  constructor(
    private reporteService: ReportesService,
    private route: ActivatedRoute,
    private workOrderService: WorkOrderService,
    private projectService: ProjectService,
    private clientService: ClientService,
    private userService: UserService,
    private pieceService: PieceService,
    private notifierService: NotifierService,
    private campaignTypeService: CampaignTypeService,
    public dialog: MatDialog,
    private routes: Router,
    private zone: NgZone,
    private dateAdapter: DateAdapter<Date>
  ) {
    this.dateAdapter.setLocale("en-GB");

    this.userService.obtenerDatosPersonales().subscribe((personal: any) => {
      this.rolParaValidar = personal.rol;
    });

    this.route.params.subscribe((params) => {
      this.userService.getUsers().subscribe(
        (result: Array<any>) => {
          this.usuarioList = result;
        },
        (error) => {
          this.notifierService.systemNotify({
            title: "Error",
            message: error.message,
            type: "error",
          });
        }
      );

      if (params["id"]) {
        this.paramId = params["id"];

        this.tableDataInternalWorkOrder = {
          columns: {
            external_code: { title: "Código" },
            detail: { title: "Descripcion" },
            aperture_date: { title: "Fecha de Apertura" },
            closed: { title: "Estado de Orden" }, // state_workflow: { title: 'Estado de Proceso' },
          },
          data: {},
        };

        this.workOrderService
          .getWorkOrder(this.paramId)
          .subscribe((workOrder: IWorkOrder) => {
            this.workOrderData = workOrder;
            this.clientService
              .getClientContacts(this.workOrderData.client_id)
              .subscribe(
                (result: any) => {
                  this.contactList = result;
                },
                (error) => {
                  this.notifierService.systemNotify({
                    title: "Ha ocurrido un error",
                    message:
                      "Por favor póngase en contacto con el administrador",
                    type: "error",
                  });
                }
              );
            this.clientService
              .getClientProducts(this.workOrderData.client_id)
              .subscribe(
                (result: any) => {
                  this.productsList = result;
                },
                (error) => {
                  this.productsList = [];
                  this.notifierService.systemNotify({
                    title: "Aviso",
                    message: "El cliente no tiene productos asignados.",
                    type: "info",
                  });
                }
              );
            this.clientService
              .getClientMarcas(this.workOrderData.client_id)
              .subscribe(
                (result: any) => {
                  //console.log('CLIENTE ID WORK ORDER DATA: ', this.workOrderData.client_id);
                  //console.log('MARCAS DEL CLIENTE: ', result);
                  this.marcasList = result;
                },
                (error) => {
                  this.marcasList = [];
                  this.notifierService.systemNotify({
                    title: "Aviso",
                    message: "El cliente no tiene marcas asignadas.",
                    type: "info",
                  });
                }
              );

            this.campaignTypeService.getAllByClient(this.workOrderData.client_id)
            .subscribe( (result) => {
              this.listCampaignTypes = result;
            })

            this.workOrderService
              .getInternalOrdersByWorkOrder(this.workOrderData.id)
              .subscribe((result) => {
                this.getTableData(result);
              });

            this.pieceService.getAllByWorkOrderId(this.workOrderData.id).subscribe( (result) => {
              
              this.arrDataPiece = result;
              
              this.getTableDataPiece(result);
            } )

          });
      } else {
        this.paramId = undefined;
      }

      this.workOrderService.getProjects().subscribe((result: any) => {
        this.projects = result;
        //console.log(this.projectList);
        this.projects.forEach((element) => {
          this.options.push(element.name);
        });

        this.filteredOptions = this.myControl.valueChanges.pipe(
          startWith(""),
          map((value) => this._filter(value))
        );
        //console.log(this.filteredOptions);
      });
    });

    if (localStorage.getItem("tipo") == "0") {
      this.workOrderData = {
        aperture_date: new Date(),
        closed: false,
        product_description: "",
        project: "",
        fee: 0,
        state_workflow: 1,
        encargado_id: 0,
      };
    }
    if (localStorage.getItem("tipo") == "1") {
      this.workOrderData = {
        aperture_date: new Date(),
        closed: false,
        product_description: "",
        project: "",
        fee: 1,
        state_workflow: 1,
        encargado_id: 0,
      };
    }

    if (localStorage.getItem("tipo") == "2") {
      this.workOrderData = {
        aperture_date: new Date(),
        closed: false,
        product_description: "",
        project: "",
        fee: 2,
        state_workflow: 1,
        encargado_id: 0,
      };
    }
  }
  typeOrder: string;
  ngOnInit() {
    this.clientService
      .getClientList()
      .subscribe((listClients: Array<IClient>) => {
        this.listClients = listClients;
      });
    //console.log(this.projects);

    this.typeOrder = this.readLocalStorageValue("tipo");
  }

  getUsuarios(event?) {
    if (event) {
      this.filteredOptions1 = event.target.value;
    }
    this.userService
      .getUsuarioByName(this.filteredOptions1.replace(/ /g, ""))
      .subscribe(
        (result) => {
          this.usuarioList = result as Array<any>;
          this.workOrderData.encargado_id = this.usuarioList[0].id;
          console.log(this.workOrderData.encargado_id);
        },
        (error) => {
          console.log("error", error);
        }
      );
  }

  /*
getProyectos1(event?) {
  if (event) {
      this.filteredOptions2 = event.target.value
  }
  this.projectService.getProjectsByNameOC(this.filteredOptions2.replace(/ /g, ""))
      .subscribe(
          result => {
              this.projectList = result as Array<any>
              this.workOrderData.project = this.projectList[0].name;
              this.idprojecto = this.projectList[0].id;
              console.log(this.projectList[0].name);

          },
          error => {
              console.log('error', error)
          }
      )
}*/

  AddProject() {
    this.clientWindow = window.open(
      environment.TBWALEGACY_URL +
        "/#/system/proyectos/nuevo/" +
        localStorage.getItem("jwt"),
      "_blank",
      "menubar=no,titlebar=no,width=780,height=650,resizeable=no"
    );
    const timer = setInterval(() => {
      if (this.clientWindow.closed) {
        clearInterval(timer);
        this.zone.run(() => {
          this.workOrderService.getProjects().subscribe((listProjects: any) => {
            this.projects = listProjects;

            this.projects.forEach((element) => {
              this.options.push(element.name);
            });

            this.filteredOptions = this.myControl.valueChanges.pipe(
              startWith(""),
              map((value) => this._filter(value))
            );
            console.log(this.projects);
          });
        });
      }
    }, 1000);
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.options.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }

  isWorkOrderClosed(): boolean {
    return this.workOrderData.closed == 1 || this.workOrderData.closed === true;
  }

  confirmArchiveWorkOrder() {
    if (!this.isWorkOrderClosed()) {
      this.notifierService.systemNotify({
        title: "Error",
        message: "La orden de trabajo debe estar cerrada para poder archivarla",
        type: "error",
      });
      return;
    }

    let archiveDialog = this.dialog.open(AlertComponent, {
      data: {
        icon: "exclamation-circle",
        iconColor: "failure",
        title: "Aviso",
        text: "¿Está seguro que desea archivar la orden de trabajo?",
        options: true     
      },
    });
    archiveDialog.afterClosed().subscribe(
      (result) => {
        if (result) {
          var state = 0;
          console.log(result);
          console.log(state);
          console.log(this.workOrderData);
          console.log(this.workOrderData.id);
          this.projectService
            .updateProjectArchivar(state, this.workOrderData.id)
            .subscribe(
              () => {
                this.notifierService.systemNotify({
                  title: "Exito",
                  message: "Se ha archivado projecto",
                  type: "success",
                });
              },
              (error) => {
                this.notifierService.systemNotify({
                  title: "Error",
                  message: error.result.message,
                  type: "success",
                });
              }
            );

          this.archiveWorkOrder();
        }
      },
      () => {
        this.notifierService.systemNotify({
          title: "Error",
          message:
            "Ha ocurrido un error por favor contacte con el administrador",
          type: "error",
        });
      }
    );
  }

  archiveWorkOrder() {
    this.workOrderData.state_workflow = 5;

    this.workOrderService.updateWorkOrder(this.workOrderData).subscribe(
      () => {
        console.log(this.workOrderData);

        this.notifierService.systemNotify({
          title: "Exito",
          message:
            "Se ha archivado la Orden de trabajo, puede verlo en la sección de Ordenes de trabajo archivados",
          type: "success",
        });
        this.routes.navigate(["/system/work-order/list"]);
      },
      (error) => {
        this.notifierService.systemNotify({
          title: "Error",
          message: error.result.message,
          type: "success",
        });
      }
    );
  }

  confirmCerrarWorkOrder() {
    let archiveDialog = this.dialog.open(AlertComponent, {
      data: {
        icon: "exclamation-circle",
        iconColor: "failure",
        title: "Aviso",
        text: "¿Está seguro que desea cerrar la orden de trabajo?",
        options: true,
      },
    });
    archiveDialog.afterClosed().subscribe(
      (result) => {
        if (result) {
          this.cerrarWorkOrder();
        }
      },
      () => {
        this.notifierService.systemNotify({
          title: "Error",
          message:
            "Ha ocurrido un error por favor contacte con el administrador",
          type: "error",
        });
      }
    );
  }

  cerrarWorkOrder() {
    this.workOrderData.state_workflow = 2;

    this.workOrderService.updateWorkOrder(this.workOrderData).subscribe(
      () => {
        this.notifierService.systemNotify({
          title: "Exito",
          message: "Se ha cerrado la Orden de trabajo",
          type: "success",
        });
        this.routes.navigate(["/system/work-order/list"]);
      },
      (error) => {
        this.notifierService.systemNotify({
          title: "Error",
          message: error.result.message,
          type: "success",
        });
      }
    );
  }

  exportExcel(fieldSearch) {
    let headerData;
    let copyData;

    headerData = [
      { dataBound: "external_code", name: "Código", width: 40 },
      { dataBound: "detail", name: "Descripcion", width: 30 },
      { dataBound: "aperture_date", name: "Fecha de apertura", width: 30 },
      { dataBound: "closed", name: "Estado de orden", width: 30 },
      { dataBound: "state_workflow", name: "Estado de proceso", width: 30 },
    ];
    const data = this.dataSourceInternalWorkOrder.filteredAndSorted;
    copyData = this.dataSourceInternalWorkOrder.filteredAndSorted;
    const nameProyect = "Reporte hora por cliente";

    const options = {
      fieldSeparator: ";",
      quoteStrings: '"',
      decimalseparator: ".",
      showLabels: true,
      useBom: true,
      headers: [
        "Código",
        "Descripcion",
        "Fecha de apertura",
        "Estado de orden",
        "Estado de proceso",
      ],
    };
    this.reporteService
      .exportExcel(headerData, copyData)
      .subscribe((result) => {
        const mediaType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const blob = new Blob([result._body], { type: mediaType });
        const fileName = "Reporte";
        fileSaver.saveAs(blob, fileName);
      });
  }

  changeNewClient() {
    this.clientWindow = window.open(
      environment.TBWALEGACY_URL +
        "/#/system/administracion/clientes/" +
        localStorage.getItem("jwt"),
      "_blank",
      "menubar=no,titlebar=no,width=780,height=650,resizeable=no"
    );
    const timer = setInterval(() => {
      if (this.clientWindow.closed) {
        clearInterval(timer);
        this.zone.run(() => {
          this.clientService
            .getClientList()
            .subscribe((listClients: Array<IClient>) => {
              this.updateContacts(this.workOrderData.client_id);
              this.listClients = listClients;
            });
        });
      }
    }, 1000);
  }

  customInternalWorkOrderAction(event) {
    switch (event.action) {
      case "editar":
        this.routes.navigate([
          "/system/work-order/internal-work-order/edit/" +
            this.workOrderData.id +
            "/" +
            event.data.id,
        ]);
        break;
    }
  }

  customPieceEvents(event) {
    switch (event.action) {
      case "editar":
        const data = event.data;

        const priceListId = this.workOrderData.id_list_price;
        const workOrderId = this.workOrderData.id;

        this.notifierService.behaviorNotify({
          action: 'edit',
          model: 'piece',
          object: {}
        });

        const dialogEdit = this.dialog.open(
        RegisterPieceDialogComponent, { 
          panelClass: 'custom-dialog-container', data: {
            priceListId,
            workOrderId,
            dataPiece: {...data}
        } });
        dialogEdit.afterClosed().subscribe((result) => {
          if (result && result.isSaved) {
            this.pieceService.getAllByWorkOrderId(this.workOrderData.id).subscribe( (result) => {
              this.arrDataPiece = result;
              this.getTableDataPiece(result);
            });
          }
        });
        break;
      case "eliminar":
        const deleteDialog = this.dialog.open(AlertComponent, {
          data: {
            icon: "exclamation-circle",
            iconColor: "failure",
            title: "Aviso",
            text: "¿Está seguro que desea remover la pieza?",
            options: true,
          },
        });
        deleteDialog.afterClosed().subscribe(
          (result) => {
            if (result) {
              this.pieceService.deletePiece(event.data.id).subscribe( (res) => {

                this.pieceService.getAllByWorkOrderId(this.workOrderData.id).subscribe( (result) => {
                  this.arrDataPiece = result;
                  this.getTableDataPiece(result);
                });

                this.notifierService.systemNotify({
                  title: "Pieza removida",
                  message: "Se removió la pieza correctamente",
                  type: "success",
                });

              })


            }
          },
          (error) => {
            let mess = error.error.message;
            this.notifierService.systemNotify({
            title: "Ha ocurrido un error",
            message: mess,
            type: "error",
          });
          }
        );
        break;
    }
  }

  copyObject(obj): object {
    return JSON.parse(JSON.stringify(obj));
  }

  getTableData(result) {
    const cloneRows: Array<any> = [...result];
    for (const item of cloneRows) {
      item.aperture_date = moment(item.aperture_date).format("DD/MM/YYYY");
      item.closed = item.closed === 1 ? "Cerrado" : "Abierto";
    }

    this.dataSourceInternalWorkOrder = new LocalDataSource(cloneRows);
    this.tableSettingsInternalWorkOrder = this.copyObject(this.settings);
    if (this.tableDataInternalWorkOrder.columns !== undefined) {
      this.tableSettingsInternalWorkOrder.columns = this.copyObject(
        this.tableDataInternalWorkOrder.columns
      );
      // Se deshabilita los filtros predefinidos para evitar conflictos
      Object.keys(this.tableSettingsInternalWorkOrder.columns).forEach(
        (key) => {
          this.tableSettingsInternalWorkOrder.columns[key].filter = true;
        }
      );
    }
  }

  getTableDataPiece(result) {
    const cloneRows: Array<any> = [...result];
    this.dataSourcePiece = new LocalDataSource(cloneRows);
    this.tableSettingsPiece = this.copyObject(this.settingsPiece);
    if (this.tableDataPiece.columns !== undefined) {
      this.tableSettingsPiece.columns = this.copyObject(
        this.tableDataPiece.columns
      );
    }

    Object.keys(this.tableSettingsPiece.columns).forEach(
      (key) => {
        this.tableSettingsPiece.columns[key].filter = true;
      }
    );
  }

  updateContacts(id_client) {
    this.productsList = [];
    this.workOrderData.product_description = null
    this.clientService.getClientProducts(id_client).subscribe(
      (result: any) => {
        if (result && result.length > 0) {
          this.productsList = result;
          this.workOrderData.product_description = result[0].name;
        }
      },
      (error) => {
        this.productsList = [];
        this.notifierService.systemNotify({
          title: "Aviso",
          message: "El cliente no tiene productos asignados.",
          type: "warning",
        });
      }
    );

    this.marcasList = []
    this.workOrderData.marca_id = null;
    this.clientService.getClientMarcas(id_client).subscribe(
      (result: any) => {
        if (result && result.length > 0) {
          this.marcasList = result;
          this.workOrderData.marca_id = result[0].id;
        }
      },
      (error) => {
        this.marcasList = [];
        this.notifierService.systemNotify({
          title: "Aviso",
          message: "El cliente no tiene marcas asignadas.",
          type: "warning",
        });
      }
    );

    this.contactList = [];
    this.workOrderData.contact = null;
    this.clientService.getClientContacts(id_client).subscribe(
      (result: any) => {
        if (result && result.length > 0) {
          this.contactList = result;
          this.workOrderData.contact = result[0].name;
        }
        //console.log("Contacts -> ", result);
      },
      (error) => {
        this.contactList = [];
        this.notifierService.systemNotify({
          title: "Ha ocurrido un error",
          message: "Por favor póngase en contacto con el administrador",
          type: "error",
        });
      }
    );

    this.workOrderData.id_campaign_type = null;
    this.listCampaignTypes = []
    this.campaignTypeService.getAllByClient(id_client).subscribe( (result)  => {  
      if (result && result.length > 0) {
        this.listCampaignTypes = [...result];
        this.workOrderData.id_campaign_type = result[0].id;
      }
    }, (error) => {
      console.log('Error tipos de campaña ', error);
    })

  }

  onProjectSelected() {
    this.projectSelected = true;
    /* this.workOrderData.project = proyecto.name;
    this.idprojecto = proyecto.id;*/
  }

  onUserSelected(selectedUsuario) {
    this.workOrderData.encargado_id = selectedUsuario.id;
  }

  readLocalStorageValue(key: string): string {
    return localStorage.getItem(key);
  }

  createWorkOrder(form: NgForm) {
    console.log(form.value);

    if (form.valid) {
      this.notifierService.systemNotify({
        title: "Espere",
        message: "Grabando Orden de trabajo",
        type: "info",
        duration: 20000,
      });
      //console.table(this.workOrderData);
      //console.table(this.listClients);
      this.workOrderData.client_code = this.listClients.find((item) => {
        // tslint:disable-next-line:triple-equals
        return item.id == Number(this.workOrderData.client_id);
      }).client_code;
      //console.log('REGISTRANDO ORDEN DE COMPRA: ', this.workOrderData);

      // Validar la fecha de cierre
      if (!this.workOrderData.close_date) {
        this.notifierService.systemNotify({
          title: "Error",
          message: "La fecha de cierre es obligatoria",
          type: "error",
        });
        return;
      } else {
        if (this.workOrderData.close_date < this.workOrderData.aperture_date) {
          this.notifierService.systemNotify({
            title: "Error",
            message:
              "La fecha de cierre debe ser posterior a la fecha de apertura",
            type: "error",
          });
          return;
        }
      }

      this.workOrderData.id_campaign_type = this.workOrderData.id_campaign_type ? Number(this.workOrderData.id_campaign_type) : null;
      this.workOrderService.createWorkOrder(this.workOrderData).subscribe(
        (result: IWorkOrder) => {
          var projectText = this.projects.find((itemProject) => {
            return itemProject.name == this.workOrderData.project;
          });
          if (!this.projectSelected || !projectText) {
            this.workOrderService
              .insertProject(result)
              .subscribe((resProject) => {});
          }
          console.log(this.idprojecto);
          console.log(this.workOrderData.id);
          console.log(result.id);
          /*this.projectService.updateProjectOT(this.idprojecto,result.id);*/
          this.notifierService.systemNotify({
            title: "Exito",
            message: "Se ha grabado con exito la OT",
            type: "success",
          });
          this.routes.navigate(["/system/work-order/edit/" + result.id]);
        },
        (error) => {
          this.notifierService.systemNotify({
            title: "Error",
            message: "Ha ocurrido un error" + error.error.message,
            type: "error",
          });
        }
      );
    } else {
      this.notifierService.systemNotify({
        title: "Error",
        message:
          "Por favor asegurese que todos los campos estén llenados correctamente",
        type: "error",
      });
    }
  }
  updateWorkOrder(form: NgForm) {
    if (form.valid) {
      this.notifierService.systemNotify({
        title: "Espere",
        message: "Actualizando Orden de trabajo",
        type: "info",
        duration: 20000,
      });
      this.workOrderData.client_code = this.listClients.find((item) => {
        return item.id === this.workOrderData.client_id;
      }).client_code;

      // Validar la fecha de cierre
      if (!this.workOrderData.close_date) {
        this.notifierService.systemNotify({
          title: "Error",
          message: "La fecha de cierre es obligatoria",
          type: "error",
        });
        return;
      } else {
        const dateApertura = new Date(this.workOrderData.aperture_date);
        const dateCierre = new Date(this.workOrderData.close_date);

        if (dateCierre < dateApertura) {
          this.notifierService.systemNotify({
            title: "Error",
            message:
              "La fecha de cierre debe ser posterior a la fecha de apertura",
            type: "error",
          });
          return;
        }
      }

      this.workOrderData.id_campaign_type = this.workOrderData.id_campaign_type ? Number(this.workOrderData.id_campaign_type) : null;
      this.workOrderService.updateWorkOrder(this.workOrderData).subscribe(
        (result: IWorkOrder) => {
          var projectText = this.projects.find((itemProject) => {
            return itemProject.name == this.workOrderData.project;
          });
          if (!this.projectSelected || !projectText) {
            this.workOrderService
              .insertProject(result)
              .subscribe((resProject) => {});
          }
          this.notifierService.systemNotify({
            title: "Exito",
            message: "Se ha grabado con exito la OT",
            type: "success",
          });
          this.routes.navigate(["/system/work-order/edit/" + result.id]);
        },
        (error) => {
          this.notifierService.systemNotify({
            title: "Error",
            message: "Ha ocurrido un error" + error.error.message,
            type: "error",
          });
        }
      );
    } else {
      this.notifierService.systemNotify({
        title: "Error",
        message:
          "Por favor asegurese que todos los campos estén llenados correctamente",
        type: "error",
      });
    }
  }
  addInternalWorkOrder() {
    this.routes.navigate([
      "/system/work-order/internal-work-order/new/" + this.paramId,
    ]);
  }

  openRegisterPieceDialog(){

    if (!this.workOrderData.id_list_price) {
      this.notifierService.systemNotify({
        title: "Error",
        message: "El cliente asociado a la orden de trabajo no tiene una lista de precios",
        type: "error",
      });

      return;
    }

    const priceListId = this.workOrderData.id_list_price;
    const workOrderId = this.workOrderData.id;

    this.notifierService.behaviorNotify({
      action: 'register',
      model: 'piece',
      object: {}
    });

    const dialogNew = this.dialog.open(
    RegisterPieceDialogComponent, { 
      panelClass: 'custom-dialog-container', data: {
        priceListId,
        workOrderId
    } });
    dialogNew.afterClosed().subscribe((result) => {
      if (result && result.isSaved) {
        this.pieceService.getAllByWorkOrderId(this.workOrderData.id).subscribe( (result) => {
          this.arrDataPiece = result;
          this.getTableDataPiece(result);
        });
      }
    });
  }

  openPieceReportDialog(){

    if (this.arrDataPiece.length == 0) {
      this.notifierService.systemNotify({
        title: "Error",
        message: "El orden de trabajo no cuenta con piezas registradas",
        type: "error",
      });

      return;
    }

    if (this.workOrderData.id) {
      const reportDialog = this.dialog.open( ReportPieceDialogComponent, {
        data: {
          workOrderId: this.workOrderData.id
        }
      })
    }

  }

  exportExcelPieceReport(){

    if (this.arrDataPiece.length == 0) {
      this.notifierService.systemNotify({
        title: "Error",
        message: "El orden de trabajo no cuenta con piezas registradas",
        type: "error",
      });

      return;
    }
    if (this.workOrderData.id) {
      this.notifierService.systemNotify({
        title: 'Descargando',
        message: 'Descargando reporte de piezas',
        type: 'info',
      });
  
      this.pieceService.getExcelReport(this.workOrderData.id)
      .subscribe( (result) => {
        let blob :any = result;
        let fileName = `report_piezas_${this.workOrderData.project}`;
        fileSaver.saveAs(blob, fileName);
        this.notifierService.systemNotify({
          title: 'Descarga completada',
          message: 'Reporte descargado correctamente',
          type: 'success',
        });
      }, (error) => {
        if (error.status == 400) {
          this.notifierService.systemNotify({
            title: 'Error',
            message: 'No se encontraron resultados para generar el reporte',
            type: 'error',
          });
        } else {
          this.notifierService.systemNotify({
            title: 'Error',
            message: 'Sucedió un error al descargar el reporte',
            type: 'error',
          });
        }
      })
    }

  }


}

export interface ICampaignType {
  id: number;
  id_client: number;
  name: string;
  description?: string | null;
  created_date?: Date | null;
  created_by?: number | null;
  updated_date?: Date | null;
  updated_by?: number | null;
}

export interface IClient {
  id: number;
  tenant: string;
  name: string;
  doc_num: string;
  address: string;
  email: string;
  client_code: string;
}
export interface IWorkOrder {
  id?: number;
  external_code?: string;
  client_id?: number;
  client_name?: string;
  product_description: string;
  project: string;
  aperture_date: Date;
  close_date?: Date;
  closed: boolean | number;
  state_workflow: number;
  create_date?: Date;
  update_date?: Date;
  create_user?: number;
  update_user?: number;
  tenant?: string;
  correlative?: number;
  client_code?: string;
  contact?: string;
  fee?: number;
  encargado_id?: number;
  nombre_completo?: string;
  marca_id?: number;
  marca_nombre?: string;
  id_campaign_type?: number | null;
  id_list_price?: number | null;
}



// WEBPACK FOOTER //
// ./src/app/system/work-order/new-work-order/new-work-order.component.ts